import DeviceDetection from '@/ports-frontend/DeviceDetection';
import Window from '@/ports-frontend/Window';

const MyAccount = {
  invoke: {
    async selfExclusionOpen([iosRedirectUrl]: [string]) {
      const {
        isNative,
        deviceOs,
        nativeDeviceOs,
      } = await DeviceDetection.getDeviceInfo();
      const isNativeIOS =
        (isNative && deviceOs === 'ios') || nativeDeviceOs === 'ios';
      if (isNativeIOS) {
        window.open(iosRedirectUrl, '_blank');
      } else {
        Window.postMessage(
          'wh.xsell.command.gaming-lobby.myAccountView.selfExclusion.open',
          '*'
        );
      }
    },
  },
};

export default MyAccount;
